/* eslint-disable no-unused-vars */
import { ECONTRACT_STATUS, EPARTY_STATUS } from "../../../enums";
import {
  EContractType,
  EEscalationStatus,
  ESenderRole,
  ETrasactionsType,
  IContractDetailsResponseData,
} from "../../../setup/api/services/contract/models";
import { Menu, MenuItem, IconButton, Badge, AlertColor } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {
  ACTION_ADMIN_CLOSE_REFUND_CUSTOMER,
  ACTION_ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER,
  ACTION_ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER,
  ACTION_ADMIN_CONFIRM_DELIVERY,
  ACTION_ADMIN_DELETE_CONTRACT,
  ACTION_ADMIN_TO_WAITING_FOR_DELIVERY,
} from "./constants";
import { ConfirmContractForm } from "./forms/confirmContractActionForm";
import { CONFIRM } from "../../authentication/constants";
import { useCallback, useEffect, useState } from "react";
import {
  ACTION_UNDER_PROCESSING,
  CANNOT_MAKE_THIS_CALL,
  CONFIRMATION_MODAL_DESCRIPTION,
  CONFIRMATION_MODAL_TITLE,
} from "../constants";
import { EContractActions } from "../../../setup/api/services/contractActions/enum";
import {
  IContractActionRequestBody,
  IContractActionResponse,
} from "../../../setup/api/services/contractActions/models";
import { getUserId } from "../../../setup/auth/oidc";
import {
  doAction,
  getAdminActorRole,
} from "../../../setup/api/services/contractActions";
import CustomizedSnackbars from "../../../components/customizedSnackbars";
import { DialogModal } from "../../../components/common/dialog";
import {
  CLOSE_WAITING_FOR_DELIVERY,
  CONFIRM_DELIVERY,
  CONFIRM_INSPECTION,
  RESOLVE_SELLER_REALSE_STATUS_DESCRIPTION,
} from "../../../components/contractListItem/constants";
import React from "react";
import SettlementModal from "../authenticatedContractDetails/SettlementModal";

import { ResolveState, ampli } from "../../../ampli";
import { settleTabbyPayment } from "../../../setup/api/services/payment";
import PrimaryButton, {
  PrimaryButtonType,
} from "../../../components/common/PrimaryButton";
import ActionButton from "../../../components/common/ActionButton/ActionButton";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { ButtonType } from "../../../components/common/button";

interface IProps {
  contract: IContractDetailsResponseData;
  isMenuOpen?: boolean;
  handleMenuClose?: () => void;
  anchorEl?: null | HTMLElement;
  feedBack?: () => void;
  receiverType?: ESenderRole;
  id: string;
  /** Lay the actions out as buttons in place of the dropdown menu. */
  inline?: boolean;
}
const ContractActions = (props: IProps) => {
  const {
    contract,
    id,
    anchorEl,
    isMenuOpen,
    handleMenuClose,
    feedBack,
    receiverType,
    inline,
  } = props;
  const userId = getUserId();
  const { t } = useTranslation();
  const [snackBarOpen, setSnackBarOpen] = useState<boolean>(false);
  const [snackBarColor, setSnackBarColor] = useState<AlertColor>();
  const [snackBarTitle, setSnackBarTitle] = useState<string>("");
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [proposeSettlementOpen, setProposeSettlementOpen] =
    useState<boolean>(false);
  const [withReferenceInput, setWithReferenceInput] = useState<boolean>(false);
  const [isCashoutPending, setIsCashoutPending] = useState<boolean>(false);
  const [currentAction, setCurrentAction] = useState<{
    action: EContractActions;
    description: string;
  }>();

  const isMilestoneContract =
    contract?.type === EContractType.MILESTONE_CONTRACT;

  const clearStates = () => {
    setCurrentAction(undefined);
    setSnackBarOpen(false);
    setModalOpen(false);
    setWithReferenceInput(false);
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const onApproveDeliveryClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.approveDelivery);
    setWithReferenceInput(false);
  };
  const onDeleteContractClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.deleteContract);
    setWithReferenceInput(false);
  };
  const onResolveRefundBuyerClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.resolveRefundBuyer);
    setWithReferenceInput(false);
  };
  const onResolveReleaseSellerClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.resolveReleaseSeller);
    setWithReferenceInput(false);
  };
  const onCloseRefundBuyerClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.closeRefundBuyer);
    setWithReferenceInput(true);
  };
  const onCloseReleaseSellerClick = () => {
    if (!isCashoutPending) {
      toggleModal();
      setCurrentAction(actionsMap.closeReleaseSeller);
      setWithReferenceInput(true);
    }
  };
  const onCompleteClick = () => {
    if (!isCashoutPending) {
      toggleModal();
      setCurrentAction(actionsMap.complete);
      setWithReferenceInput(true);
    }
  };
  const onSettleClick = () => {
    toggleModal();
    setWithReferenceInput(true);
    setCurrentAction(actionsMap.settle);
  };

  const onAcceptInspection = () => {
    toggleModal();
    setCurrentAction(actionsMap.acceptInspection);
  };
  const onToWaitingForDeliveryClick = () => {
    toggleModal();
    setCurrentAction(actionsMap.toWaitingForDelivery);
    setWithReferenceInput(false);
  };
  const actionsMap = {
    settle: {
      action: EContractActions.ADMIN_SETTLE_TRANSACTION,
      description: "",
    },
    approveDelivery: {
      action: EContractActions.ADMIN_CONFIRM_DELIVERY,
      description: CONFIRMATION_MODAL_DESCRIPTION.APPROVE_DELIVERY,
    },
    resolveRefundBuyer: {
      action: EContractActions.ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER,
      description:
        CONFIRMATION_MODAL_DESCRIPTION.ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER,
    },
    resolveReleaseSeller: {
      action: EContractActions.ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER,
      description:
        CONFIRMATION_MODAL_DESCRIPTION.ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER,
    },
    closeRefundBuyer: {
      action: EContractActions.ADMIN_CLOSE_REFUND_CUSTOMER,
      description: CONFIRMATION_MODAL_DESCRIPTION.ADMIN_CLOSE_REFUND_CUSTOMER,
    },
    closeReleaseSeller: {
      action: EContractActions.ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER,
      description:
        CONFIRMATION_MODAL_DESCRIPTION.ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER,
    },
    complete: {
      action: EContractActions.ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER,
      description:
        CONFIRMATION_MODAL_DESCRIPTION.ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER,
    },
    acceptInspection: {
      action: EContractActions.ADMIN_ACCEPT_ITEM,
      description: CONFIRMATION_MODAL_DESCRIPTION.ADMIN_ACCEPT_ITEM,
    },
    deleteContract: {
      title: CONFIRMATION_MODAL_TITLE.ADMIN_DELETE_ITEM,
      action: EContractActions.ADMIN_DELETE_CONTRACT,
      description: CONFIRMATION_MODAL_DESCRIPTION.ADMIN_DELETE_ITEM,
    },
    toWaitingForDelivery: {
      action: EContractActions.ADMIN_TO_WAITING_FOR_DELIVERY,
      description: CONFIRMATION_MODAL_DESCRIPTION.ADMIN_TO_WAITING_FOR_DELIVERY,
    },
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const sendResolveEscalationEvent = (
    currentAction: EContractActions,
    buyerId: string,
    contractId: string,
    sellerId: string
  ) => {
    if (
      currentAction ===
        EContractActions.ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER ||
      currentAction ===
        EContractActions.ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER
    ) {
      let resolveState = ResolveState.Refund;
      if (
        currentAction ===
        EContractActions.ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER
      ) {
        resolveState = ResolveState.Release;
      }
      const properties = {
        adminResolveDate: String(new Date()),
        buyerId: buyerId,
        contractId: contractId,
        resolveState: resolveState,
        sellerId: sellerId,
      };
      try {
        ampli && ampli.adminResolveEscalation(properties);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const sendRefundReleaseEvent = (
    currentAction: EContractActions,
    buyerId: string,
    contractId: string,
    sellerId: string
  ) => {
    if (
      currentAction === EContractActions.ADMIN_CLOSE_REFUND_CUSTOMER ||
      currentAction === EContractActions.ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER
    ) {
      const properties = {
        adminRefundDate: String(new Date()),
        buyerId: buyerId,
        contractId: contractId,
        sellerId: sellerId,
      };
      try {
        if (currentAction === EContractActions.ADMIN_CLOSE_REFUND_CUSTOMER)
          ampli.adminRefundBuyer(properties);
        if (
          currentAction ===
          EContractActions.ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER
        )
          ampli.adminReleaseSeller(properties);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const doContractAction = async (res?: IContractActionResponse) => {
    if (res && res?.sent == true) {
      setSnackBarStates(ACTION_UNDER_PROCESSING, "success");
    } else {
      setSnackBarStates(CANNOT_MAKE_THIS_CALL, "error");
    }
    clearStates();
    handleMenuClose?.();
    feedBack?.();
  };

  const acceptPayment = useCallback(async () => {
    if (!userId) return;
    try {
      const body = {
        contractId: contract?.id,
        userId: userId,
        actorRole: getAdminActorRole(),
        receiverId: String(contract?.receiverId),
        senderId: String(contract?.senderId),
        contractAction: EContractActions.ADMIN_VERIFY_PAYMENT,
      };
      await doAction(body);
      setSnackBarStates(ACTION_UNDER_PROCESSING, "success");
      window.location.reload();
    } catch (error) {
      setSnackBarStates(`${CANNOT_MAKE_THIS_CALL} ${error}`, "error");
      console.log("error", error);
    }
  }, [contract?.id, contract?.receiverId, contract?.senderId, userId]);

  const rejectPayment = useCallback(async () => {
    if (!userId) return;
    try {
      const body = {
        contractId: contract?.id,
        userId: userId,
        actorRole: getAdminActorRole(),
        receiverId: String(contract?.receiverId),
        senderId: String(contract?.senderId),
        contractAction: EContractActions.ADMIN_DENY_PAYMENT,
      };
      await doAction(body);
      setSnackBarStates(ACTION_UNDER_PROCESSING, "success");
      window.location.reload();
    } catch (error) {
      setSnackBarStates(`${CANNOT_MAKE_THIS_CALL} ${error}`, "error");
      console.log("error", error);
    }
  }, [contract?.id, contract?.receiverId, contract?.senderId, userId]);

  const onConfirm = async (userInput?: string) => {
    if (!userId) return;
    if (currentAction) {
      const contractActionBody: IContractActionRequestBody = {
        contractId: contract.id,
        userId: userId,
        actorRole: getAdminActorRole(),
        receiverId: contract?.receiverId,
        senderId: contract.senderId,
        contractAction: currentAction?.action,
        transactionId: userInput,
      };

      try {
        let normalRes;
        if (
          currentAction?.action === actionsMap.settle?.action &&
          (contract.status ===
            ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_RESOLVE ||
            contract.status ===
              ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_CLOSE) &&
          contract.transactions.some(
            (transaction) =>
              transaction.type === ETrasactionsType.CUSTOMER_PAY &&
              (transaction.paymentMethod === "TABBY" ||
                transaction.paymentMethod === "NEO" ||
                transaction.paymentMethod === "TAMARA")
          )
        ) {
          if (userInput) normalRes = await settleTabbyPayment(userInput);
        } else {
          normalRes = await doAction(contractActionBody);

          if (normalRes && normalRes?.sent === true) {
            sendResolveEscalationEvent(
              currentAction.action,
              (contract?.senderRole === ESenderRole.CUSTOMER
                ? contract?.senderId
                : contract?.receiverId) || "",
              contract.shortId,
              (contract?.senderRole === ESenderRole.CUSTOMER
                ? contract?.receiverId
                : contract?.senderId) || ""
            );

            sendRefundReleaseEvent(
              currentAction.action,
              (contract?.senderRole === ESenderRole.CUSTOMER
                ? contract?.senderId
                : contract?.receiverId) || "",
              contract.shortId,
              (contract?.senderRole === ESenderRole.CUSTOMER
                ? contract?.receiverId
                : contract?.senderId) || ""
            );
          }
        }
        doContractAction(normalRes);
      } catch (error) {
        setSnackBarStates(`${CANNOT_MAKE_THIS_CALL} ${error}`, "error");
        doContractAction(undefined);
      }
    }
  };

  const setSnackBarStates = (title: string, color: AlertColor) => {
    setSnackBarOpen(true);
    setSnackBarColor(color);
    setSnackBarTitle(title);
  };
  const renderModal = () => {
    return (
      <DialogModal
        title={CONFIRM}
        open={modalOpen}
        handleClose={async () => {
          closeModal();
        }}>
        <ConfirmContractForm
          contract={contract}
          onConfirm={onConfirm}
          onCancel={closeModal}
          withReferenceInput={withReferenceInput}
          description={currentAction?.description || ""}
        />
      </DialogModal>
    );
  };
  // Every admin action the contract's status allows, in display order. The
  // dropdown menu and the inline buttons are both built from this list.
  const availableActions: {
    key: string;
    label: string;
    onClick: () => void;
    danger?: boolean;
  }[] = [
    ...((contract.status === ECONTRACT_STATUS.DELIVERY_ESCALATION ||
      contract.status === ECONTRACT_STATUS.INSPECTION_ESCALATION) &&
    contract.type === EContractType.MILESTONE_CONTRACT &&
    [
      EEscalationStatus.OPEN,
      EEscalationStatus.RESOLVED_CUSTOMER,
      EEscalationStatus.RESOLVED_PROVIDER,
    ].includes(
      contract.escalations?.find((e) => !e.resolved)
        ?.status as EEscalationStatus
    )
      ? [
          {
            key: "proposeSettlement",
            label: t("lbl_propose_settlement"),
            onClick: () => {
              setProposeSettlementOpen(true);
              handleMenuClose?.();
            },
          },
        ]
      : []),
    ...(contract.status === ECONTRACT_STATUS.DELIVERY_ESCALATION
      ? [
          {
            key: "approveDeliveryEscalation",
            label: ACTION_ADMIN_CONFIRM_DELIVERY,
            onClick: onApproveDeliveryClick,
          },
          {
            key: "toWaitingForDelivery",
            label: ACTION_ADMIN_TO_WAITING_FOR_DELIVERY,
            onClick: onToWaitingForDeliveryClick,
          },
        ]
      : []),
    ...(contract.status === ECONTRACT_STATUS.CREATED ||
    contract.status === ECONTRACT_STATUS.SUBMITTED
      ? [
          {
            key: "deleteContract",
            label: ACTION_ADMIN_DELETE_CONTRACT,
            onClick: onDeleteContractClick,
            danger: true,
          },
        ]
      : []),
    ...(contract.status === ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_RESOLVE ||
    contract.status === ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_CLOSE
      ? [
          {
            key: "settle",
            label: t("lbl_settle_transaction_title"),
            onClick: onSettleClick,
          },
        ]
      : []),
    ...((contract.status === ECONTRACT_STATUS.WAITING_FOR_DELIVERY ||
      contract.status === ECONTRACT_STATUS.ITEM_INSPECTION) &&
    contract.type !== EContractType.MILESTONE_CONTRACT
      ? [
          {
            key: "resolveReleaseSeller",
            label: RESOLVE_SELLER_REALSE_STATUS_DESCRIPTION,
            onClick: onResolveReleaseSellerClick,
          },
        ]
      : []),
    ...(contract.status === ECONTRACT_STATUS.WAITING_FOR_DELIVERY
      ? [
          ...(contract.type !== EContractType.MILESTONE_CONTRACT
            ? [
                {
                  key: "resolveRefundBuyer",
                  label: CLOSE_WAITING_FOR_DELIVERY,
                  onClick: onResolveRefundBuyerClick,
                },
              ]
            : []),
          {
            key: "approveDelivery",
            label: CONFIRM_DELIVERY,
            onClick: onApproveDeliveryClick,
          },
        ]
      : []),
    ...(contract.status === ECONTRACT_STATUS.ITEM_INSPECTION
      ? [
          {
            key: "acceptInspection",
            label: CONFIRM_INSPECTION,
            onClick: onAcceptInspection,
          },
        ]
      : []),
  ];

  const renderActionsMenu = () => {
    return (
      <Menu
        anchorEl={anchorEl}
        dir="rtl"
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        id={id}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={!!isMenuOpen}
        onClose={handleMenuClose}>
        {availableActions.map((action) => (
          <MenuItem key={action.key} onClick={action.onClick}>
            <IconButton size="large" color="inherit">
              <Badge>
                <EditIcon />
              </Badge>
            </IconButton>
            <p>{action.label}</p>
          </MenuItem>
        ))}
      </Menu>
    );
  };

  const renderInlineActions = () => {
    return availableActions.map((action) => (
      <PrimaryButton
        key={action.key}
        buttonType={
          action.danger ? PrimaryButtonType.DANGER : PrimaryButtonType.DEFAULT
        }
        style={{
          width: "auto",
          height: "40px",
          padding: "0 16px",
          borderRadius: "8px",
          whiteSpace: "nowrap",
          fontSize: "14px",
          lineHeight: "100%",
          fontWeight: 500,
          ...(action.danger ? {} : { background: "#0D44AD" }),
        }}
        onClick={action.onClick}>
        {action.label}
      </PrimaryButton>
    ));
  };
  const renderSnackBar = () => {
    return snackBarOpen ? (
      <CustomizedSnackbars
        open={snackBarOpen}
        title={snackBarTitle}
        type={snackBarColor}
      />
    ) : null;
  };

  const renderActionsButton = () => {
    if (!isMilestoneContract) return <></>;
    return (
      <div className={styles["button_container"]}>
        {/* {contract?.status === ECONTRACT_STATUS.DELIVERY_ESCALATION && (
          <PrimaryButton onClick={onApproveDeliveryClick}>
            {ACTION_ADMIN_CONFIRM_DELIVERY}
          </PrimaryButton>
        )} */}
        {(contract?.status === ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER ||
          contract?.status === ECONTRACT_STATUS.PARTIALLY_REFUNDED) &&
          receiverType === ESenderRole.CUSTOMER && (
            <ActionButton onClick={onCloseRefundBuyerClick}>
              {ACTION_ADMIN_CLOSE_REFUND_CUSTOMER}
            </ActionButton>
          )}
        {(contract?.status === ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER ||
          contract?.status === ECONTRACT_STATUS.PARTIALLY_RESOLVE_RELEASED) &&
          receiverType === ESenderRole.PROVIDER && (
            <ActionButton
              onClick={onCloseReleaseSellerClick}
              buttonType={
                (isCashoutPending
                  ? ButtonType.DISABLED
                  : ButtonType.DEFAULT) as unknown as PrimaryButtonType
              }>
              {isCashoutPending
                ? t("lbl_cashout_already_exists")
                : ACTION_ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER}
            </ActionButton>
          )}
        {(contract?.status === ECONTRACT_STATUS.ITEM_ACCEPTED ||
          contract?.status === ECONTRACT_STATUS.PARTIALLY_RELEASED) &&
          (receiverType === ESenderRole.PROVIDER ||
            receiverType === ESenderRole.BROKER) && (
            <ActionButton
              onClick={onCompleteClick}
              buttonType={
                (isCashoutPending
                  ? ButtonType.DISABLED
                  : ButtonType.DEFAULT) as unknown as PrimaryButtonType
              }>
              {isCashoutPending
                ? t("lbl_cashout_already_exists")
                : t("lbl_release")}
            </ActionButton>
          )}
        {(contract?.status === ECONTRACT_STATUS.PARTIALLY_PAID ||
          contract?.status === ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION) &&
          receiverType === ESenderRole.CUSTOMER && (
            <div className={styles["transfer_options_container"]}>
              <ActionButton backgroundColor={"#44C16E"} onClick={acceptPayment}>
                {t("lbl_accept_payment")}
              </ActionButton>
              <ActionButton
                buttonType={PrimaryButtonType.DANGER}
                onClick={rejectPayment}>
                {t("lbl_reject_payment")}
              </ActionButton>
            </div>
          )}
        {/* {contract?.status === ECONTRACT_STATUS.WAITING_FOR_DELIVERY && (
          <PrimaryButton onClick={onResolveReleaseSellerClick}>
            {RESOLVE_SELLER_REALSE_STATUS_DESCRIPTION}
          </PrimaryButton>
        )}
        {contract?.status === ECONTRACT_STATUS.WAITING_FOR_DELIVERY && (
          <PrimaryButton onClick={onResolveRefundBuyerClick}>
            {CLOSE_WAITING_FOR_DELIVERY}
          </PrimaryButton>
        )} */}
        {/* {contract?.status === ECONTRACT_STATUS.WAITING_FOR_DELIVERY && (
          <PrimaryButton onClick={onApproveDeliveryClick}>
            {CONFIRM_DELIVERY}
          </PrimaryButton>
        )} */}
      </div>
    );
  };

  return (
    <>
      {renderSnackBar()}
      {renderModal()}
      {inline ? renderInlineActions() : renderActionsMenu()}
      {renderActionsButton()}
      <SettlementModal
        open={proposeSettlementOpen}
        handleClose={() => setProposeSettlementOpen(false)}
        propose
      />
    </>
  );
};

export default React.memo(ContractActions);
